// Libraries
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// Services
import { SessionService } from '../services/SessionService';
import { UserService } from '../services/UserService';
import { LocalStorageService } from '../../core/services';
import { AdminService } from '../../../../common/modules/admin/services/AdminService'

@Component({
    selector: 'user-logout',
    template: '',
    styles: [],
})

export class LogoutComponent {
    private errorMessage: string;
    protected hostName: string;
    // For logout navigate
    protected devEnv: any = ['camp.eca.dev.nascorp.vn', 'asa.eca.dev.nascorp.vn', 'holiday.eca.dev.nascorp.vn', 'bus.eca.dev.nascorp.vn', 'reen.eca.dev.nascorp.vn'];
    protected testEnv: any = ['camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn', 'reen.eca.test.nascorp.vn'];
    protected stagingEnv: any = ['auth.eca.uat.nascorp.vn','services.eca.uat.nascorp.vn','asa.eca.uat.nascorp.vn','holidayschool.eca.uat.nascorp.vn','bus.eca.uat.nascorp.vn','outdooreducation.eca.uat.nascorp.vn','reen.eca.uat.nascorp.vn','acs.eca.uat.nascorp.vn','pcbs.eca.uat.nascorp.vn'];
    protected procEnv: any = ['outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com', 'reen.aisvietnam.com']

    constructor(
        private router: Router,
        private sessionService: SessionService,
        private localStorageService: LocalStorageService,
        private userService: UserService,
        private adminService: AdminService
    ) { }

    ngOnInit() {
        this.hostName = window.location.hostname;
        // Delete session from system
        this.deleteSession();
    }

    /**
     * Delete user session data.
     */
    private deleteSession() {
        this.sessionService.deleteSession()
            .subscribe(
                complete => {
                    // Clear user session
                    this.userService.clearUserSessionData();
                    this.adminService.clearInterSession();

                    // Fire user session data changed event
                    this.userService.userDataChanged(null);

                    // Redirect to desired URL                    
                    if (this.devEnv.indexOf(this.hostName) !== -1) {
                        return window.location.href = 'http://services.eca.dev.nascorp.vn';
                    }
                    else if (this.testEnv.indexOf(this.hostName) !== -1) {
                        return window.location.href = 'http://services.eca.test.nascorp.vn';
                    }
                    else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
                        return window.location.href = 'http://services.eca.uat.nascorp.vn';
                    }
                    else if (this.procEnv.indexOf(this.hostName) !== -1) {
                        return window.location.href = 'https://services.aisvietnam.com';
                    }
                    else {
                        return window.location.href = 'http://services.local.eca.dev.nascorp.vn';
                    }
                },
                error => this.errorMessage = <any>error
            );
    }

    // Redirect to desired url
    private redirect(redirectUrl: string) {
        this.router.navigate([redirectUrl]);
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/user/logout/LogoutComponent.ts